import React from "react";
import SidebarCollapsableItem from "./SidebarCollapsableItem";

const SidebarLinksForMobile = ({ linksCollapsedForMobile, sidebarLinks }) => {
  return (
    <div
      style={{ top: `${linksCollapsedForMobile ? "-400px" : ""}` }}
      className="custom-scrollbar tw-text-secondary tw-fixed tw-top-[60px] sidebar-links-content tw-right-0 tw-left-0 tw-transition-all tw-duration-300 tw-max-h-[250px] tw-overflow-y-auto tw-z-50 tw-block md:tw-hidden"
    >
      <ul className="!tw-my-0">
        {sidebarLinks?.map((sidebarItem, index) => (
          <div key={index}>
            <SidebarCollapsableItem sidebarItem={sidebarItem} />
          </div>
        ))}
      </ul>
    </div>
  );
};

export default SidebarLinksForMobile;
